module.exports = __webpack_public_path__ + "static/group-pic-9cdfe34e05da0da9833c1b1efda6343e.png";